import { Injectable } from '@angular/core';
import { Url } from './util/protocol';
import { DotcmsConfig } from './dotcms-config.service';
import { LoggerService } from './logger.service';
import { EventsSocket } from './util/socket';
import { Observable } from 'rxjs/Rx';
import { CoreWebService } from './core-web.service';
var SocketFactory = (function () {
    function SocketFactory(dotcmsConfig, loggerService, coreWebService) {
        this.dotcmsConfig = dotcmsConfig;
        this.loggerService = loggerService;
        this.coreWebService = coreWebService;
    }
    SocketFactory.prototype.createSocket = function () {
        var _this = this;
        this.loggerService.debug('Creating socket object');
        return Observable.create(function (observer) {
            _this.dotcmsConfig.getConfig().subscribe(function (configParams) {
                var url = new Url(configParams.websocketProtocol, configParams.websocketBaseURL, configParams.websocketsSystemEventsEndpoint);
                if (!_this.socket) {
                    _this.socket = new EventsSocket(url, configParams, _this.loggerService, _this.coreWebService);
                }
                observer.next(_this.socket);
                observer.complete();
            });
        });
    };
    SocketFactory.prototype.clean = function () {
        this.socket = null;
    };
    return SocketFactory;
}());
export { SocketFactory };
SocketFactory.decorators = [
    { type: Injectable },
];
/** @nocollapse */
SocketFactory.ctorParameters = function () { return [
    { type: DotcmsConfig, },
    { type: LoggerService, },
    { type: CoreWebService, },
]; };
//# sourceMappingURL=socket-factory.service.js.map